import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { TextInput, SelectInput } from '../FormElements';
interface BasicsFormProps {
  role: 'brand' | 'organizer';
  onNext: (data: any) => void;
}
export function BasicsForm({
  role,
  onNext
}: BasicsFormProps) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    type: '',
    customType: ''
  });
  const buttonColor = role === 'brand' ? 'bg-cyan-500 hover:bg-cyan-400 text-slate-900' : 'bg-purple-600 hover:bg-purple-500 text-white';
  const shadowColor = role === 'brand' ? 'rgba(6,182,212,0.3)' : 'rgba(168,85,247,0.3)';
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Use custom type if "Other" is selected
    const finalType = formData.type === 'Other' ? formData.customType : formData.type;
    onNext({
      ...formData,
      type: finalType
    });
  };
  const industryOptions = role === 'brand' ? ['Technology', 'Fashion', 'Food & Beverage', 'Finance', 'Health & Wellness', 'Entertainment', 'Automotive', 'Sports', 'Travel', 'Other'] : ['Conference', 'Festival', 'Sports Event', 'Concert', 'Trade Show', 'Community Event', 'Charity Event', 'Corporate Event', 'Other'];
  return <div className="max-w-xl mx-auto" data-id="element-880">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-center mb-10" data-id="element-881">
        <h1 className="text-4xl font-bold text-white mb-4" data-id="element-882">
          Let's get started
        </h1>
        <p className="text-xl text-slate-400" data-id="element-883">
          {role === 'brand' ? 'Join thousands of brands finding their perfect sponsorship match.' : 'Connect your event with sponsors who align with your values.'}
        </p>
      </motion.div>

      <motion.form initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.1
    }} onSubmit={handleSubmit} className="bg-slate-900/50 border border-slate-800 rounded-2xl p-8" data-id="element-884">
        <TextInput label={role === 'brand' ? 'Company Name' : 'Event / Organization Name'} placeholder={role === 'brand' ? 'e.g. Acme Corp' : 'e.g. Tech Summit 2024'} value={formData.name} onChange={e => setFormData({
        ...formData,
        name: e.target.value
      })} required data-id="element-885" />

        <TextInput label="Work Email" type="email" placeholder="you@example.com" value={formData.email} onChange={e => setFormData({
        ...formData,
        email: e.target.value
      })} required data-id="element-886" />

        <SelectInput label={role === 'brand' ? 'Industry' : 'Event Type'} value={formData.type} onChange={e => setFormData({
        ...formData,
        type: e.target.value,
        customType: ''
      })} options={industryOptions} required data-id="element-887" />

        {/* Custom type input when "Other" is selected */}
        {formData.type === 'Other' && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} data-id="element-888">
            <TextInput label={role === 'brand' ? 'Please specify your industry' : 'Please specify your event type'} placeholder={role === 'brand' ? 'e.g. Renewable Energy, EdTech...' : 'e.g. Hackathon, Art Exhibition...'} value={formData.customType} onChange={e => setFormData({
          ...formData,
          customType: e.target.value
        })} required data-id="element-889" />
          </motion.div>}

        <button type="submit" className={`w-full py-4 rounded-full font-bold text-lg transition-all shadow-[0_0_20px_${shadowColor}] mt-6 flex items-center justify-center gap-2 ${buttonColor}`} data-id="element-890">
          Continue <ArrowRight size={20} data-id="element-891" />
        </button>

        <p className="text-center text-sm text-slate-500 mt-6" data-id="element-892">
          Questions? Contact us at{' '}
          <a href="mailto:info@sponsrai.se" className={role === 'brand' ? 'text-cyan-400 hover:text-cyan-300' : 'text-purple-400 hover:text-purple-300'} data-id="element-893">
            info@sponsrai.se
          </a>
        </p>
      </motion.form>
    </div>;
}